// @ts-strict-ignore
import WithContainerRoute from 'mobile_web/modules/common/hocs/container-route'
import React, { FC } from 'react'
import { RouteComponentProps } from 'react-router'
import { getComponentParams } from '../../home/functions'
import CollectionListComponent from '../components/CollectionList'

const CollectionListRoute: FC<RouteComponentProps> = ({ location: { state }, match: { params } }) => {
	const { id, version, accountId } = getComponentParams('collection', params, state)

	return <CollectionListComponent collectionId={id} collectionVersion={version} accountId={accountId} />
}

export default WithContainerRoute(CollectionListRoute)
